type TranscriptionAPIResponse = Array<{
	chunks: Array<any>;
	id: string;
	input_tokens: number;
	seconds: number | null;
	text: string;
	total_tokens: number;
}>;

// https://hello.atlassian.net/wiki/spaces/CA3/pages/5173751347/Audio+Streaming+Endpoint+Tech+Spec
export const getTranscriptions = async ({
	audioString,
}: {
	audioString: string;
}): Promise<TranscriptionAPIResponse> => {
	const response = await fetch('/gateway/api/v1/audio/transcriptions', {
		method: 'POST',
		body: JSON.stringify({
			data: [{ audio: audioString }],
			model: 'whisper-1',
			audio_format: 'wav',
		}),
		headers: {
			'Content-Type': 'application/json',
			'Request-ID': crypto.randomUUID(),
		},
	});

	if (!response.ok) {
		throw new Error(`HTTP error! status: ${response.status}`);
	}

	if (!response.body) {
		throw new Error('Response body is null');
	}

	return response.json();
};
